function ProfessorFinder() {
    return (
      <>
        <p>test2</p>
      </>
    );
  }
  
export default ProfessorFinder;